class SectionBulletedContent extends window.BAO.CustomElement() {
  checkValidity () {
    super.checkValidity()

    this.els.trigger?.elements.forEach(el => {
      if (!el.dataset.index) {
        this.throwError('Trigger element must have a data-index attribute')
      }
    })

    this.els.target?.elements.forEach(el => {
      if (!el.dataset.index) {
        this.throwError('Target element must have a data-index attribute')
      }
    })
  }

  setupListeners () {
    super.setupListeners()

    this.onMouseEnter = this.onMouseEnter.bind(this)

    if (this.els.trigger?.exists) {
      this.els.trigger.elements.forEach(el => {
        this.listeners.add(el, 'mouseenter', this.onMouseEnter)
      })
    }
  }

  /**
   * @param {MouseEvent} event
   */
  onMouseEnter (event) {
    const index = event.target.dataset.index
    const target = this.querySelector(
      `${this.els.target.selector}[data-index="${index}"]`,
    )

    if (!target) return

    this.els.trigger.elements.forEach(triggerEl => {
      triggerEl.setAttribute(
        'aria-current',
        (triggerEl === event.target).toString(),
      )
    })

    this.els.target.elements.forEach(targetEl => {
      targetEl.setAttribute('aria-hidden', (target !== targetEl).toString())
    })

    if (window.BAO.MediaBreakpoints.isSm) return

    this.els.media.element.scrollIntoView({ behavior: 'smooth' })
  }
}

if (!customElements.get('section-bulleted-content')) {
  customElements.define('section-bulleted-content', SectionBulletedContent)
}
